import { crudRequest } from '@/services/api';

const params = {}
export default {
    namespace: 'sitearrivedvicekanban',
    state: {
        detailCenter: '',
        onSearch: false,
        centerFilter: ''
    },

    effects: {
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
}
